<template>
  <div
    class="p-4 rounded-md"
    :class="{
      'border-l-4 bg-red-50 border-red-400': type === 'error',
      'bg-yellow-50 border-yellow-400': type === 'alert',
      'bg-green-50 border-green-400': type === 'success',
      'bg-blue-50 border-blue-400': type === 'info'
    }"
  >
    <div class="flex">
      <div class="flex-shrink-0" v-if="type == 'error'">
        <XCircleIcon class="h-5 w-5 text-red-600" aria-hidden="true" />
      </div>
      <div class="flex-shrink-0" v-if="type == 'success'">
        <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
      </div>
      <div class="flex-shrink-0" v-if="type == 'alert'">
        <ExclamationTriangleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
      </div>
      <div class="flex-shrink-0" v-if="type == 'info'">
        <InformationCircleIcon class="size-5 text-blue-400" aria-hidden="true" />
      </div>
      <div class="ml-2">
        <h3
          v-if="title"
          class="text-sm font-bold m-0 pt-1"
          :class="{ 'text-red-800': type === 'error', 'text-green-800': type !== 'error' }"
        >
          {{ title }}
        </h3>
        <div class="mt-2 text-sm text-black" v-if="message">
          <p>{{ message }}</p>
        </div>
        <div
          @click="$emit('customLinkClick')"
          class="text-sm text-black"
          :class="title || message ? 'mt-2' : ''"
          v-if="html"
        >
          <span v-html="htmlMessage"></span>
          <span v-if="customLink" class="font-bold text-xs underline cursor-pointer text-tdefault-color">
            {{ customLink }}
            <component v-if="customIcon" :is="customIcon" class="h-3 w-3 inline-block" aria-hidden="true" />
          </span>
        </div>
      </div>
      <div class="ml-auto pl-3 self-center" v-if="showClose">
        <div class="-mx-1.5 -my-1.5">
          <button
            :class="{
              'bg-red-50 focus:ring-red-600 focus:ring-offset-red-50': type === 'error',
              'bg-yellow-50 focus:ring-yellow-600 focus:ring-offset-yellow-50': type === 'alert',
              'bg-green-50 focus:ring-green-600 focus:ring-offset-green-50': type === 'success',
              'bg-blue-50 focus:ring-blue-600 focus:ring-offset-blue-50': type === 'info'
            }"
            type="button"
            class="inline-flex rounded-md p-1.5 text-pdsPrimaryColor focus:outline-none focus:ring-2 focus:ring-offset-2"
            @click="$emit('close')"
          >
            <span class="sr-only">Dismiss</span>
            <XMarkIcon class="size-6 mr-2" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
  CheckCircleIcon,
  XMarkIcon
} from '@heroicons/vue/20/solid';

export default {
  name: 'Alert',
  components: {
    ExclamationTriangleIcon,
    XCircleIcon,
    CheckCircleIcon,
    InformationCircleIcon,
    XMarkIcon
  },
  props: {
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    html: {
      type: Boolean,
      default: false
    },
    htmlMessage: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: false
    },
    customLink: {
      type: String,
      default: ''
    },
    customIcon: {
      type: [Object, Function],
      default: null
    }
  },
  emits: ['close', 'customLinkClick'],
  setup() {
    return {};
  }
};
</script>
